/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Header(props) {
  const { t } = useTranslation();
  return (
    <div className='p-0'>
      <nav className="navbar navbar-expand-lg fixed-top navbar-dark">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            I <i class="fa-solid fa-heart"></i> Watson
          </Link>
          
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
            <ul className="navbar-nav align-items-center">
              <li className="nav-item">
                <Link to="/AboutUs" className="navbar-brand">
                  {t('about_us')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;